module.exports = __webpack_public_path__ + "static/media/usage.bbea926d.png";